/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description: 
 */
import React from "react";
import PropTypes from "prop-types";
import "./style.less";
import axios from 'axios/dist/axios.min.js'
import utils from "../../utils/utils";
// import { LazyLoadImage } from 'react-lazy-load-image-component';
import shihuo from 'shihuo-lib/dist/shihuo-lib';

class PipelineSpringFestivalFloor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      goodsList: [],
      curTabIndex: 0,
      navFixed: false
    }
    this.templateId = 85992400;
    this.canExposure = false
    this.goods_type = 2;
    this.pageId = typeof window !== "undefined" && window.location.host === "zt-public.shihuo.cn"
      ? window.location.href.indexOf('zt-public.shihuo.cn/stage') > -1
        ? window.location.pathname.split("/")[3]
        : window.location.pathname.split("/")[2]
      : 0;
  }

  componentDidMount() {
    const { baseConfig } = this.props.config;
    this.goods_type = baseConfig.squareStageType == '预售' ? 1 : (baseConfig.squareStageType == '预热' ? 2 : (baseConfig.squareStageType == '全部商品' ? 0 : 3))
    this.getMainPushGoodsList();

    window.addEventListener("scroll", this.onScroll);
  }

  // 基于商品id / 配色id 抓取商品信息
  goodsListByIds = (ids) => {
    return new Promise((resolve, reject) => {
      axios({
        url: 'https://sh-gateway.shihuo.cn/v4/services/sh-venueapi/common/goodsListByIds?access_token=znSnA7pxO35wtPBaur',
        method: "post",
        withCredentials: true,
        data: {
          goods_id: ids,
          goods_type: this.goods_type
        },
      }).then(res => {
        const { status, data } = res.data;
        if (status === 0) {
          const list = data.goods_list;
          resolve(list);
        } else {
          resolve([]);
        }
      })
    })
  }

  // 基于二级类目id 抓取商品信息
  goodsListByCate = (ids) => {
    return new Promise((resolve, reject) => {
      axios({
        url: 'https://sh-gateway.shihuo.cn/v4/services/sh-venueapi/common/goodsListByCate?access_token=znSnA7pxO35wtPBaur',
        method: 'post',
        withCredentials: true,
        data: {
          cate: ids,
          page_size: 60,
          page_on: 1,
          goods_type: this.goods_type,
          from: window.location.href,
          scene: 'ACTIVITY_11_GOODSLIST_REC',
          goods_from: 0
        },
      }).then(res => {
        const { status, data } = res.data;
        if (status === 0) {
          const list = data.goods_list;
          resolve(list);
        } else {
          resolve([]);
        }
      })
    })
  }

  // 获取楼层主推商品列表
  getMainPushGoodsList = () => {
    let requestIndex = 0;  // 楼层数据请求的数量
    const { senceTabList } = this.props.config;
    senceTabList.length > 0 && senceTabList.forEach((senceTabItem, senceTabIndex) => {
      const { floorBgImage, mainPush, categoryTabBgImage, categoryTabHoverBgImage, categoryListBgImage, categoryTab } = senceTabItem.senceFloor;

      const moduleElement = {
        index: senceTabIndex,
        tabTitle: senceTabItem.tabTitle,
        tabBgImage: senceTabItem.tabBgImage,
        tabHoverBgImage: senceTabItem.tabHoverBgImage,
        tabCurIndex: 0,
        floorBgImage,
        categoryTabBgImage,
        categoryTabHoverBgImage,
        categoryListBgImage,
        mainTitle: mainPush.mainTitle,
        subTitle: mainPush.subTitle,
        showBrowserMore:  mainPush.showBrowserMore,
        browserMoreImage: mainPush.browserMoreImage,
        browserMoreLink: mainPush.browserMoreLink,
        mainPushProBgImage: mainPush.mainPushProBgImage,
        configType: mainPush.configType,
        categoryTab: categoryTab,
        mainPushList: [],
      }

      const pref = mainPush.configType === "商品id" ? 'g' : 'p'
      const itemList = mainPush.mainPushProductList;
      const idList = itemList.map((item) => {
        return isNaN(Number(item.id)) ? 0 : pref + item.id;
      });

      this.goodsListByIds(idList).then(res => {
        // 插入定制化内容
        if (!res) {
          return;
        }
        res.length > 0 && res.forEach((product, indexNum) => {
          if (mainPush.configType === "商品id") {
            const customItem = itemList.find && itemList.find((item) => item.id == product.goodsId);
            if (customItem) {
              product.custom_image = customItem.image;
              product.custom_title = customItem.title;
              product.custom_subTitle = customItem.subTitle;
            }
          } else {
            const customItem = itemList.find && itemList.find((item) => item.id == product.styleId);
            if (customItem) {
              product.custom_image = customItem.image;
              product.custom_title = customItem.title;
              product.custom_subTitle = customItem.subTitle;
            }
          }
        });
        Object.assign(moduleElement, {
          mainPushList: res.length > 2 ? this.getRandomMainPush(res, 2) : res
        })
        let goodsList = this.state.goodsList;
        goodsList.push(moduleElement);
        
        goodsList = this.handleFloorSort(goodsList);
        this.setState({
          goodsList
        }, () => {
          requestIndex++;
          if (requestIndex >= 3) {
            this.getFloorCategoryInfo();
          }
        })
      });
    });
  }

  // 获取楼层类目商品列表
  getFloorCategoryInfo() {
    const { goodsList } = this.state;
    goodsList.length > 0 && goodsList.forEach((senceTabItem, senceTabIndex) => {
      const { categoryTab } = senceTabItem;
      const curTab = categoryTab && categoryTab.length > 0 && categoryTab[0];
      
      this.getFloorCategoryGoodsInfo(categoryTab, curTab, senceTabIndex, 0, true);
    })
  }

  // 获取楼层类目商品信息
  /**
   * 
   * @param {*} dataSource     目标楼层数据源
   * @param {*} targetCate     目标楼层中的目标类目
   * @param {*} senceTabIndex  目标楼层索引
   * @param {*} targetIndex    目标楼层中的目标类目索引
   * @param {*} isInit         是否是初始化
   * @returns 
   */
  getFloorCategoryGoodsInfo = (dataSource, targetCate, senceTabIndex, targetIndex, isInit) => {
    if (!targetCate) {
      return;
    }
    console.log('targetCate', targetCate)
    const goodsList = this.state.goodsList;
    const { tabName, configType, layout_goodsId, layout_styleId, layout_categoryId, layout_custom } = targetCate;

    const activeCateProInfo = {
      configType: configType,
      tabName: tabName,
      showRangeStart: 0,
      showRangeEnd: 6,
      showSwitch: true,
      list: []
    }

    if (configType === "商品id(维度)" || configType === "配色id(维度)") {
      const prefix = configType === "商品id(维度)" ? 'g' : 'p'
      const itemList = ((layout_goodsId && layout_goodsId.id) || (layout_styleId && layout_styleId.id)).split(",") || [];
      const ids = itemList.map((item) => {
        return isNaN(Number(item)) ? 0 : prefix + item;
      });

      this.goodsListByIds(ids).then(res => {
        const list = res;
        Object.assign(activeCateProInfo, {
          list,
          showSwitch: activeCateProInfo.showRangeEnd <= list.length && activeCateProInfo.showRangeEnd + 6 <= list.length
        });

        if (isInit) {
          Object.assign(goodsList[senceTabIndex], {
            categoryTab: dataSource,
            curCategoryTab: activeCateProInfo,
          });
        } else {
          Object.assign(goodsList[senceTabIndex], {
            curCategoryTab: activeCateProInfo,
            tabCurIndex: targetIndex
          });
        }

        this.setState({
          goodsList
        });

      });
    } else if (configType === "二级类目id(维度)") {
      const ids = layout_categoryId.id && layout_categoryId.id.split(",") || [];
      this.goodsListByCate(ids).then(res => {
        const list = res;
        Object.assign(activeCateProInfo, {
          list,
          showSwitch: activeCateProInfo.showRangeEnd <= list.length && activeCateProInfo.showRangeEnd + 6 <= list.length
        });

        if (isInit) {
          Object.assign(goodsList[senceTabIndex], {
            categoryTab: dataSource,
            curCategoryTab: activeCateProInfo,
          });
        } else {
          Object.assign(goodsList[senceTabIndex], {
            curCategoryTab: activeCateProInfo,
            tabCurIndex: targetIndex
          })
        }

        this.setState({
          goodsList
        });

      })
    } else {
      console.log('layout_custom', layout_custom);
      const list = layout_custom.categoryProductList;
      Object.assign(activeCateProInfo, {
        list,
        showSwitch: activeCateProInfo.showRangeEnd <= list.length && activeCateProInfo.showRangeEnd + 6 <= list.length
      });

      if (isInit) {
        Object.assign(goodsList[senceTabIndex], {
          categoryTab: dataSource,
          curCategoryTab: activeCateProInfo,
        });
      } else {
        Object.assign(goodsList[senceTabIndex], {
          curCategoryTab: activeCateProInfo,
          tabCurIndex: targetIndex
        });
      }

      this.setState({
        goodsList
      });

    }
  }

  // 楼层类目Tab点击切换
  handleCategoryTab = (floorIndex, categoryTabIndex, tabName, floorItem) => {
    const options = {
      page_id: utils.getPageId(),
      miniSence: tabName,
      floor_name: floorItem.tabTitle,
      tab_name: tabName,
      tabChName: floorItem.tabTitle,
      model_block: '小场景Tab'
    }
    utils.uploadTrack(this.props, {}, {
      ptiId: `lego-specialTopic:senceFloor-categorySet-tab:${categoryTabIndex}`,
      bizExtra: options
    })

    const { goodsList } = this.state;
    const {categoryTab} = goodsList[floorIndex];
    const targetTab = goodsList[floorIndex].categoryTab[categoryTabIndex];
    this.getFloorCategoryGoodsInfo(categoryTab, targetTab, floorIndex, categoryTabIndex, false);
  }

  // 楼层主推商品随机展示
  getRandomMainPush = (arr, n) => {
    const result = [];
    for (let i = 0; i < n; i++) {
      var random = Math.floor(Math.random() * arr.length);
      if(result.includes && result.includes(arr[random])){
          continue;
      }
      result.push(arr[random]);
      arr.splice(random,1);
    }
    return result;  
  }

  // 场景Tab点击
  handleTabItemClick(item, index) {
    const options = {
      page_id: utils.getPageId(),
      block_name: '楼层Tab',
      tabChName: item.tabTitle,
      model_block: '楼层Tab'
    }
    utils.uploadTrack(this.props, {
      sort: index,
      name: item.tabTitle,
    }, {
      ptiId: `lego-specialTopic:senceFloor-tab:${index}`,
      bizExtra: options
    });
    const scrollerY = window.document.querySelectorAll('.sence-floor')[index].offsetTop - this.props.navigationBarHeight - window.document.querySelector('.sence-nav-container').clientHeight;
    window.scrollTo(0, scrollerY);
    this.setState({
      curTabIndex: index,
    });
  }

  onScroll = () => {
    const tabBar = window.document.querySelector('.sence-nav-container');

    if (!tabBar) {
      return;
    }

    const tabBarHeight = tabBar.clientHeight
    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;
    const navOffsetTop = tabBar.offsetTop - this.props.navigationBarHeight + (utils.isAndroid() ? -44 : 0);
    const navFixed = scrollHeight - navOffsetTop >= 0 && scrollHeight - navOffsetTop <= window.document.querySelector('.pipeline-springFestival-floor').clientHeight - tabBarHeight

    if (navFixed != this.state.navFixed) {
      this.setState({
        navFixed
      });
    }

    const list = window.document.querySelectorAll('.sence-floor') || [];
    const stopIndex = list.length - 1
    for (let i = 0; i < list.length; i += 1) {
      const item = list[i]
      if (item && scrollHeight >= item.offsetTop - tabBarHeight - this.props.navigationBarHeight + (utils.isAndroid() ? -45 : 0)) {
        if (i == list.length - 1 || scrollHeight < list[i + 1].offsetTop - tabBarHeight - this.props.navigationBarHeight + (utils.isAndroid() ? -45 : 0)) {
          const curTabIndex = i > stopIndex ? stopIndex : i
          if (curTabIndex != this.state.curTabIndex) {
            this.setState({
              curTabIndex
            })
          }
          break
        }
      }
    }
  }

  // Tab楼层随机排序
  handleFloorSort = (arr) => {
    return arr.sort((a, b) => {
      return a.index - b.index
    });;
  }

  // 换一换
  handleSwitch = (target, dataSource) => {
    const { tabTitle } = dataSource;
    const options = {
      floor_name: tabTitle,
      tab_name: target.tabName,
      tabChName: tabTitle,
      model_block: '换一换'
    }
    utils.uploadTrack(this.props, {}, {
      ptiId: `lego-specialTopic:senceFloor-categorySet-tab_${dataSource.tabCurIndex}-changed`,
      bizExtra: options
    })

    if (target.configType === '商品id(维度)' || target.configType === '配色id(维度)' || target.configType === '自定义(维度)') {
      if (target.list >= 12) {
        target.showSwitch = true;
      }

      target.showRangeStart += 6;
      target.showRangeEnd += 6;
      if (target.showRangeEnd > target.list.length) {
        target.showRangeStart = 0;
        target.showRangeEnd = 6;
      }
      this.setState({});
    } else {
      if (target.list >= 12) {
        target.showSwitch = true;
      }

      target.showRangeStart += 6;
      target.showRangeEnd += 6;
      if (target.showRangeEnd > target.list.length) {
        target.showRangeStart = 0;
        target.showRangeEnd = 6;
      }
      this.setState({});
    }
  }

  renderSwitch(target, dataSource) {
    if (!target || !target.configType) {
      return null;
    }
    let showSwitch = false;
    if (target.configType === '商品id' || target.configType === '配色id' || '自定义') {
      showSwitch = target.showSwitch
    } else {
      showSwitch = true;
    }

    if (showSwitch) {
      return (
        <div className="switch-btn" onClick={() => this.handleSwitch(target, dataSource)}>
          <img src="https://static.shihuocdn.cn/admin/files/20211216/2cbac0d9b02c7c0b6159f4218f801d8d.png" alt="" />
          <p>换一换</p>
        </div>
      )
    } else {
      return null;
    }
  }

  render() {
    const { baseConfig, senceTabList } = this.props.config
    const { curTabIndex, navFixed, goodsList } = this.state;
    if (goodsList.length < 0) {
      return null;
    }
    return (
      <div
        className="pipeline-springFestival-floor"
        {...this.props['customAttributes']}
        style={{
          marginTop: `${baseConfig.moduleMarginTop}px`,
          marginLeft: `${baseConfig.moduleMarginHorizon}px`,
          marginRight: `${baseConfig.moduleMarginHorizon}px`,
        }}
      >
        <div className="container">
          <div className="sence-nav-container">
            <ul 
              className="sence-tab-list"
              style={{
                position: navFixed ? 'fixed' : 'relative',
                top: navFixed ? this.props.navigationBarHeight : 0,
                backgroundColor: navFixed ? window.backgroundColor : 'transparent',
                zIndex: 10
              }}
            >
              {
                goodsList.map((tabItem, tabIndex) => {
                  return (
                    <li 
                      className={curTabIndex == tabIndex ? `tab-item selected` : 'tab-item'} key={tabIndex}
                      style={{
                        backgroundImage: `url('${utils.formatImgUrl(curTabIndex == tabIndex ? tabItem.tabHoverBgImage : tabItem.tabBgImage, this.props.webpSupport)}')`,
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat"
                      }}
                      onClick={this.handleTabItemClick.bind(this, tabItem, tabIndex)}
                    >
                      
                    </li>
                  )
                })
              }
            </ul>
          </div>
          {
            goodsList.map((floorItem, floorIndex) => {
              return (
                <div
                  className="sence-floor"
                  key={floorIndex}
                  style={{
                    background: `url(${utils.formatImgUrl(floorItem.floorBgImage, this.props.webpSupport)}) no-repeat`,
                    backgroundSize: "100% 100%",
                    marginTop: floorIndex === 0 && 8
                  }}
                >
                  <div className="main-push-pro">
                    <h3 className="main-title">{floorItem.mainTitle && floorItem.mainTitle.slice(0, 6)}</h3>
                    <p className="sub-title">{floorItem.subTitle}</p>
                    {
                      floorItem.showBrowserMore === '是' && (
                        <div className="view-more" onClick={() => {
                          const options = {
                            floor_name: floorItem.tabTitle,
                            tabChName: floorItem.tabTitle,
                            model_block: '查看更多'
                          }
                          const detailHref = floorItem.browserMoreLink;

                          utils.jumpToUrl(
                            this.props.routeParams,
                            detailHref,
                            detailHref,
                            {},
                            -1,
                            this.props,
                            false,
                            {
                              ptiId: `lego-specialTopic:senceFloor-more`,
                              bizExtra: options
                            }
                          );
                        }}>
                          <img src={utils.formatImgUrl(floorItem.browserMoreImage, this.props.webpSupport)} alt="" />
                        </div>
                      )
                    }
                    {
                      floorItem.mainPushList.map((mainPushItem, mainPushIndex) => {
                        const { pic, goodsName, price, detailHref, custom_image, custom_title, custom_subTitle, goodsId, styleId } = mainPushItem;
                        if (this.canExposure) {
                          return (
                            <div 
                              className="main-push-item" 
                              key={mainPushIndex}
                              style={{background: `url(${utils.formatImgUrl(floorItem.mainPushProBgImage, this.props.webpSupport)}) no-repeat`,backgroundSize: "100% 100%"}}
                              onClick={() => {
                                const options = {
                                  tabChName: floorItem.tabTitle,
                                  model_block: '主推商品',
                                  goods_id: mainPushItem.goodsId,
                                  style_id: mainPushItem.styleId,
                                  floor_name: floorItem.tabTitle
                                }
                                utils.jumpToUrl(
                                  this.props.routeParams,
                                  detailHref,
                                  detailHref,
                                  {
                                    goods_id: goodsId,
                                    style_id: styleId
                                  },
                                  -1,
                                  this.props,
                                  false,
                                  {
                                    ptiId: `lego-specialTopic:senceFloor-mainGoods:${mainPushIndex}`,
                                    bizExtra: options
                                  }
                                ); 
                              }}
                            >
                              <img src={utils.formatImgUrl(custom_image || pic, this.props.webpSupport)} alt="" />
                              <div className="pro-info">
                                <p className="title">{custom_title || goodsName}</p>
                                <p className="desc">{custom_subTitle && custom_subTitle.slice(0, 8)}</p>
                                <p className="price">¥{price}</p>
                              </div>
                            </div>
                          ) 
                        } else {
                          return (
                            <div 
                              className="main-push-item" 
                              key={mainPushIndex}
                              style={{background: `url(${utils.formatImgUrl(floorItem.mainPushProBgImage, this.props.webpSupport)}) no-repeat`,backgroundSize: "100% 100%"}}
                              onClick={() => {
                                const options = {
                                  tabChName: floorItem.tabTitle,
                                  model_block: '主推商品',
                                  goods_id: mainPushItem.goodsId,
                                  style_id: mainPushItem.styleId,
                                  floor_name: floorItem.tabTitle
                                }
                                utils.jumpToUrl(
                                  this.props.routeParams,
                                  detailHref,
                                  detailHref,
                                  {
                                    goods_id: goodsId,
                                    style_id: styleId
                                  },
                                  -1,
                                  this.props,
                                  false,
                                  {
                                    ptiId: `lego-specialTopic:senceFloor-mainGoods:${mainPushIndex}`,
                                    bizExtra: options
                                  }
                                ); 
                              }}
                            >
                              <img src={utils.formatImgUrl(custom_image || pic, this.props.webpSupport)} alt="" />
                              <div className="pro-info">
                                <p className="title">{custom_title || goodsName}</p>
                                <p className="desc">{custom_subTitle && custom_subTitle.slice(0, 8)}</p>
                                <p className="price">¥{price}</p>
                              </div>
                            </div>
                          )
                        }
                      })
                    }
                  </div>
                  <ul className="category-tab-list">
                    {floorItem.categoryTab && floorItem.categoryTab.map((categoryTabItem, categoryTabIndex) => {
                      return (
                        <li 
                          className="category-tab-item"
                          style={{
                            backgroundImage: `url(${utils.formatImgUrl(categoryTabIndex === floorItem.tabCurIndex ? floorItem.categoryTabHoverBgImage : floorItem.categoryTabBgImage, this.props.webpSupport)})`,
                            backgroundSize: "100% 100%"
                          }}
                          key={categoryTabIndex}
                          onClick={() => this.handleCategoryTab(floorIndex, categoryTabIndex, categoryTabItem.tabName, floorItem)}
                        >
                          {categoryTabItem.tabName}
                        </li>
                      )
                    })}
                  </ul>
                  <div
                    className="category-pro-wrap"
                    style={{
                      backgroundImage: `url(${utils.formatImgUrl(floorItem.categoryListBgImage, this.props.webpSupport)})`,
                      backgroundSize: "100% 100%"
                    }}
                  >
                    <ul className="category-pro-list">
                      {floorItem.curCategoryTab && floorItem.curCategoryTab.list.slice(floorItem.curCategoryTab.showRangeStart, floorItem.curCategoryTab.showRangeEnd).map((categoryProItem, categoryProIndex) => {
                        if (this.canExposure) {
                          return (
                            <li
                              key={categoryProIndex}
                              onClick={() => {
                                const options = {
                                  tab_name: floorItem.curCategoryTab.tabName,
                                  goods_id: categoryProItem.goodsId,
                                  style_id: categoryProItem.styleId,
                                  floor_name: floorItem.tabTitle,
                                  tabChName: floorItem.tabTitle,
                                  model_block: '小场景卡片',
                                }
                                const detailHref = categoryProItem.detailHref || categoryProItem.link;
                                utils.jumpToUrl(
                                  this.props.routeParams,
                                  detailHref,
                                  detailHref,
                                  {
                                    goods_id: categoryProItem.goodsId || categoryProItem.id,
                                    style_id: categoryProItem.styleId || categoryProItem.id
                                  },
                                  -1,
                                  this.props,
                                  false,
                                  {
                                    ptiId: `lego-specialTopic:senceFloor-list:${floorIndex}`,
                                    bizExtra: options
                                  }
                                );
                              }}
                            >
                              <img src={utils.formatImgUrl(categoryProItem.pic || categoryProItem.image, this.props.webpSupport)} alt="" />
                              <div className="pro-item">
                                <p className="title">{categoryProItem.goodsName || categoryProItem.title}</p>
                                <p className="hot">{categoryProItem.tag || categoryProItem.subTitle}</p>
                                <p className="price">¥{categoryProItem.price}</p>
                              </div>
                            </li>
                          )
                        } else {
                          return (
                            <li
                              key={categoryProIndex}
                              onClick={() => {
                                const options = {
                                  tab_name: floorItem.curCategoryTab.tabName,
                                  goods_id: categoryProItem.goodsId,
                                  style_id: categoryProItem.styleId,
                                  floor_name: floorItem.tabTitle,
                                  tabChName: floorItem.tabTitle,
                                  model_block: '小场景卡片',
                                }
                                const detailHref = categoryProItem.detailHref || categoryProItem.link;
                                utils.jumpToUrl(
                                  this.props.routeParams,
                                  detailHref,
                                  detailHref,
                                  {
                                    goods_id: categoryProItem.goodsId || categoryProItem.id,
                                    style_id: categoryProItem.styleId || categoryProItem.id
                                  },
                                  -1,
                                  this.props,
                                  false,
                                  {
                                    ptiId: `lego-specialTopic:senceFloor-list:${floorIndex}`,
                                    bizExtra: options
                                  }
                                );
                              }}
                            >
                              <img src={utils.formatImgUrl(categoryProItem.pic || categoryProItem.image, this.props.webpSupport)} alt="" />
                              <div className="pro-item">
                                <p className="title">{categoryProItem.goodsName || categoryProItem.title}</p>
                                <p className="hot">{categoryProItem.tag || categoryProItem.subTitle}</p>
                                <p className="price">¥{categoryProItem.price}</p>
                              </div>
                            </li>
                          )
                        }
                      })}
                    </ul>
                    { this.renderSwitch(floorItem.curCategoryTab, floorItem) }
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    );
  }
}

PipelineSpringFestivalFloor.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineSpringFestivalFloor };
export default PipelineSpringFestivalFloor;


// WEBPACK FOOTER //
// ./components/pipeline-springFestivalFloor/index.js